import { AvailabilityProvidersComponent } from 'app/components/availability-providers/AvailabilityProvidersComponent'
import { useAvailabilityProviders } from 'app/components/availability-providers/useAvailabilityProviders'

export default function Providers() {
  const hookData = useAvailabilityProviders()
  return <AvailabilityProvidersComponent {...hookData} />
}
